/* eslint semi:0 */
import { namespacedConsts } from '../../utils/object'
import { appDispatcher } from '../../application/AppDispatcher'

const SLIDESHOW_CONSTANTS = namespacedConsts({
  SLIDESHOW: {
    ACTIONS: {
      START_SLIDE_CHANGE: true,
      COMPLETE_SLIDE_CHANGE: true,
      SLIDESHOW_INITIALIZATION_FINISHED: true,
    },
  },
})

export const TYPES = SLIDESHOW_CONSTANTS.SLIDESHOW.ACTIONS

export const startSlideChange = slideEventObject => {
  appDispatcher.dispatchAction.view({
    type: TYPES.START_SLIDE_CHANGE,
    slideEventObject,
  })
}

export const completeSlideChange = slideId => {
  appDispatcher.dispatchAction.view({
    type: TYPES.COMPLETE_SLIDE_CHANGE,
    slideId,
  })
}
export const slideshowInitializationFinished = () => {
  appDispatcher.dispatchAction.view({
    type: TYPES.SLIDESHOW_INITIALIZATION_FINISHED,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/slideshowActions.js